import { gql } from "@apollo/client";

/**
 * „Parašyk mums" — the support channel.
 *
 * The categories are the one closed list the form offers and the triage prompt
 * is bounded by, served from `SupportRequest::CATEGORIES`. Reading them from the
 * server rather than duplicating them here is what stops the page offering a
 * category the server then refuses.
 */
export const GET_SUPPORT_CATEGORIES = gql`
  query GetSupportCategories {
    supportCategories
  }
`;

/** The queue at /admin/support. Admin only, and so is every field on it. */
export const GET_SUPPORT_REQUESTS = gql`
  query GetSupportRequests($status: String, $category: String) {
    supportRequests(status: $status, category: $category) {
      id
      category
      categoryLabel
      summary
      status
      resolved
      filedBy
      reportedByRole
      occurrences
      firstSeenAt
      lastSeenAt
      resolvedAt
      copiedAt
      transcript
      requestContext
      studentName
      studentId
    }
    openSupportRequests
  }
`;

/**
 * „Dažni klausimai", from content/faq.yml — the same entries the triage prompt
 * gets. Read from the server rather than duplicated here so the page, the modal
 * and the model cannot disagree about what the answer is.
 */
export const GET_FAQ = gql`
  query GetFaq {
    faq
  }
`;
